import { render } from "./DraftProjectsComponent.vue?vue&type=template&id=1d1c379c&scoped=true&ts=true"
import script from "./DraftProjectsComponent.vue?vue&type=script&lang=ts"
export * from "./DraftProjectsComponent.vue?vue&type=script&lang=ts"

import "./DraftProjectsComponent.vue?vue&type=style&index=0&id=1d1c379c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1c379c"]])

export default __exports__